module.exports = __webpack_public_path__ + "static/media/profile_yokohamaminatocfc6cfcab96b4304dead652d2ac0b29b.webp";